const actions = {
    FETCH_GALLERIES : 'FETCH_GALLERIES',
    FETCH_GALLERY  : 'FETCH_GALLERY',
    RESET_GALLERY  : 'RESET_GALLERY',

    fetchGalleriesAction: (data) => {
        return {
            type: actions.FETCH_GALLERIES,
            data: data
        };
    },
    resetGalleryFormAction: () => {
        return {
            type: actions.RESET_GALLERY,
            data: null
        };
    },
    fetchGalleryAction: (data) => {
        return {
            type: actions.FETCH_GALLERY,
            data: data
        };
    },
}

export default actions;
